import { Injectable } from '@angular/core';

import { ConfigurationService } from '../../services/configuration.service';

@Injectable()
export class BrandDivisionService extends ConfigurationService {

    public modelPath = 'pharmacy/brand_divisions';

    getDTColumns () {
        const self = this;
        return [{
            name: 'division_id',
            title: 'Division Id',
            visible: false,
            orderable: false,
            searchable: false,
            data: 'division_id'
        }, {
            name: 'division_name',
            title: 'Division Name',
            data: 'division_name'
        }, {
            title: 'Status',
            orderable: false,
            searchable: false,
            render: function (data: any, type: any, full: any) {
                if (self.globalHelper.checkUserAccess('configuration/update-brand-division')) {
                    return `<div class="custom-control custom-checkbox">
						<input class="custom-control-input" data-modelPk="checkbox_${full.division_id}" id="checkbox_${full.division_id}" type="checkbox" />
						<label class="custom-control-label" for="checkbox_${full.division_id}"></label>
					</div>`;
                }
                return `<label class="label label-${full.status === 1 ? 'success' : 'danger'}">
					${full.status === 1 ? 'Active' : 'Inactive'}
				</label>`;
            }
        }, {
            title: 'Action',
            orderable: false,
            searchable: false,
            render: function (data: any, type: any, full: any) {
                if (self.globalHelper.checkUserAccess('configuration/update-brand-division')) {
                    return `<a href="javascript:void(0)" data-modelPk="${full.division_id}" class="btn btn-secondary">
						<i data-modelPk="${full.division_id}" class="icon-pencil"></i>
					</a>`;
                }
                return '';
            }
        }];
    }
}
